import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryContracts (params) {
  return request({
    ...APIS['@contractInfo/Query_Contracts'],
    params
  })
}

export function updateContract (data) {
  return request({
    ...APIS['@contractInfo/Update_Contract'],
    data
  })
}

export function deleteContract (params) {
  return request({
    ...APIS['@contractInfo/Delete_Contract'],
    params
  })
}

export function deleteService (params) {
  return request({
    ...APIS['@contractInfo/DeleteService'],
    params
  })
}

export function queryServices (params) {
  return request({
    ...APIS['@contractInfo/Query_Services'],
    params
  })
}

export function addContract (data) {
  return request({
    ...APIS['@contractInfo/Add_Contract'],
    data
  })
}

export function exportContracts (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@contractInfo/Export_Contracts'],
    params,
    headers,
    responseType
  })
}
